import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-leave-scribe-dialog',
  templateUrl: './leave-scribe-dialog.component.html',
  styleUrls: ['./leave-scribe-dialog.component.scss']
})
export class LeaveScribeDialogComponent implements OnInit {

  constructor(
  private dialogRef: MatDialogRef<LeaveScribeDialogComponent>,
  ) { }

  ngOnInit(): void {
  }

  leaveScribe(){
    this.dialogRef.close(true);
  }

  cancel(){
    this.dialogRef.close(false);
  }
}
